<div class="toolbar">
  <div class="years" *ngIf="allYears.length>1">
    <button mat-button *ngFor="let year of allYears" (click)="selectedYear$.next(year)"
      [color]="(selectedYear$ | async) === year ? 'primary' : undefined">
      {{ year }}
    </button>
    <button mat-button (click)="selectedYear$.next(null)"
      [color]="(selectedYear$ | async) === null ? 'primary' : undefined">
      Összes
    </button>
  </div>

  <div class="mail" *ngIf="DISPLAY_SEND_M30_BUTTON && forAdmin">
    <button mat-button (click)="onSendMailClick()"
      [disabled]="(isMailSending$ | async) || !(isSomeSelected$ | async)" color="primary">
      Email küldés a kijelölteknek
      <span *ngIf="(isMailSending$ | async)">...</span>
    </button>
  </div>
</div>

<div class="loader" *ngIf="isTableLoading$ | async"></div>
<div class="send-mail-progress" *ngIf="DISPLAY_SEND_M30_BUTTON && (isMailSending$ | async)">
  <div class="mail-placeholder" *ngFor="let mail of mailsBeingSent$ | async | keyvalue"
    [ngClass]="mail.value"
    [title]="getMailProgressBarMsg(mail.key)">
  </div>
</div>
<div class="error" *ngIf="error$ | async">{{ error$ | async }}</div>

<mat-table [dataSource]="(filteredM30$ | async) ?? []" *ngIf="!(isTableLoading$ | async)" class="mat-elevation-z8">
  <!-- Selector checkboxes -->
  <ng-container matColumnDef="select">
    <th mat-header-cell *matHeaderCellDef>
      <mat-checkbox (change)="masterToggle()" [checked]="isAllSelected()" 
      [indeterminate]="(isSomeSelected$ | async) && !isAllSelected()"
      [disabled]="(isMailSending$ | async)">
      </mat-checkbox>
    </th>
    <td mat-cell *matCellDef="let item">
      <mat-checkbox (click)="$event.stopPropagation()" (change)="toggleSelection(item)"
        [checked]="isSelected(item)"
        [disabled]="(isMailSending$ | async)">
      </mat-checkbox>
    </td>
  </ng-container>
  
  <!-- ID Column -->
  <ng-container matColumnDef="m30id">
    <th mat-header-cell *matHeaderCellDef>#</th>
    <td mat-cell *matCellDef="let item">{{ item.m30id }}</td>
  </ng-container>

  <!-- Year Column -->
  <ng-container matColumnDef="year">
    <th mat-header-cell *matHeaderCellDef>Év</th>
    <td mat-cell *matCellDef="let item">{{ item.year }}</td>
  </ng-container>

  <!-- Production Name Column -->
  <ng-container matColumnDef="prodname">
    <th mat-header-cell *matHeaderCellDef>Produkció</th>
    <td mat-cell *matCellDef="let item">{{ item.prodname }}</td>
  </ng-container>

  <!-- Email Column -->
  <ng-container matColumnDef="email">
    <th mat-header-cell *matHeaderCellDef>Email</th>
    <td mat-cell *matCellDef="let item">{{ item.email }}</td>
  </ng-container>

  <!-- Infos Column -->
  <ng-container matColumnDef="infos">
    <th mat-header-cell *matHeaderCellDef>Név</th>
    <td mat-cell *matCellDef="let item">
      {{ item.infos?.[0].familyName }} {{ item.infos?.[0].userName }}
      <span *ngIf="item.infos?.length > 1" class="unimportant">x {{ item.infos.length }}</span>
    </td>
  </ng-container>

  <!-- Tax Number Column -->
  <ng-container matColumnDef="taxnum">
    <th mat-header-cell *matHeaderCellDef>Adószám</th>
    <td mat-cell *matCellDef="let item">{{ item.taxnum }}</td>
  </ng-container>

  <!-- PDF Column -->
  <ng-container matColumnDef="pdf">
    <th mat-header-cell *matHeaderCellDef style="text-align: center;">PDF</th>
    <td mat-cell *matCellDef="let item" style="text-align: center;">

      <button mat-button color="primary" 
      [disabled]="(pdfLoading$ | async) === item.m30id" (click)="downLoadClicked(item)">
      Letöltés {{ (pdfLoading$ | async) === item.m30id ? '...' : '' }}
    </button>
      <!-- <span *ngIf="!item.pdf">-</span> -->
    </td>
  </ng-container>

  <!-- Download Date Column -->
  <ng-container matColumnDef="downloadDate">
    <th mat-header-cell *matHeaderCellDef>Letöltés dátuma</th>
    <td mat-cell *matCellDef="let item">
      <span *ngIf="item.downloadDate; else notDownloaded">
              {{ (item.downloadDate | date:'yyyy-MM-dd') }}
      </span>
      <ng-template #notDownloaded>
        <span class="unimportant">Nincs letöltve</span>
      </ng-template>
    </td>
  </ng-container>

  <tr mat-header-row
    *matHeaderRowDef="displayedColumns">
  </tr>
  <tr mat-row
    *matRowDef="let row; columns: displayedColumns;">
  </tr>
  <tr class="mat-row" *matNoDataRow>
    <td class="mat-cell" [attr.colspan]="displayedColumns.length">
      Nincs letölthető M30 pdf.
    </td>
  </tr>
</mat-table>


<!-- <button type="button" (click)="test()">teszt</button> -->